module.exports = __webpack_public_path__ + "media/images/wintak_civ_blk_cord-c656178962619b2b056a553bf2a52798.png";